module.exports = __webpack_public_path__ + "7dd063e573b2efba2591da9517888ebb.MP3";